var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[(_vm.block.text)?_c('div',[_c('Wysiwyg',{attrs:{"content":_vm.block.text}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }